/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];


